module.exports = __webpack_public_path__ + "img/icon_2_25.c074c1f6.png";